import { forwardRef } from 'react';

interface PlatformContainerProps {
  children: React.ReactNode;
  containerCustomClassname?: string;
  contentCustomClassnames?: string;
  ref?: React.LegacyRef<HTMLDivElement>;
  overflowY?: boolean;
}

const PlatformContainer = forwardRef<HTMLDivElement, PlatformContainerProps>(
  ({ children, containerCustomClassname, contentCustomClassnames, overflowY = true }, ref) => {
    return (
      <div
        className={[`w-full ${overflowY ? 'overflow-y-auto' : ''} no-scrollbar h-full`, containerCustomClassname]
          .filter(Boolean)
          .join(' ')}>
        <div
          className={['container max-sm:px-4 max-w-6xl h-full', contentCustomClassnames].filter(Boolean).join(' ')}
          ref={ref}>
          {children}
        </div>
      </div>
    );
  }
);

PlatformContainer.displayName = 'PlatformContainer';

export default PlatformContainer;
